<template>
  <div class="page-container" v-if="!!previewData && !loading">
    <div class="header-container">
      <div class="left">
        <div class="arrow" @click="onExit">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M11.3177 2.59996L11.3531 2.56461L11.3177 2.52925L10.7531 1.96464L10.7177 1.92929L10.6824 1.96464L4.68239 7.96464L4.64703 8L4.68239 8.03536L10.6824 14.0354L10.7177 14.0707L10.7531 14.0354L11.3177 13.4707L11.3531 13.4354L11.3177 13.4L5.91767 8L11.3177 2.59996Z" fill="#111111" stroke="#111111" stroke-width="0.1"/>
          </svg>
        </div>

        <p class="label">{{ previewData.offer.first_header ?? previewData.offer.quick_text ?? 'Unknown' }}</p>
        <span v-if="activation.document_state !== null" class="chip" :class=chipStateClass(activation.document_state)>
          {{ activation.document_state | state }}
        </span>
        <span v-html="stateInformation(activation)"/>
      </div>
      <div class="right">
        <div class="display-options">
          <button class="device" :class="{'active' : previewDevice === 1}" @click="previewDevice = 1">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M15.0994 5C12.9394 5 11.1364 6.96822 11.1364 9.09091V30.9091C11.1364 32.1848 11.7622 33.2235 12.5639 33.9134C13.3656 34.6032 14.3297 35 15.2273 35H25.0497C27.1351 35 28.8636 33.2715 28.8636 31.1861V8.81392C28.8636 6.72852 27.1351 5 25.0497 5H15.0994ZM15.0994 6.36364H25.0497C26.3734 6.36364 27.5 7.49023 27.5 8.81392V31.1861C27.5 32.5098 26.3734 33.6364 25.0497 33.6364H15.2273C14.7612 33.6364 14.0208 33.3754 13.4588 32.8906C12.8968 32.4059 12.5 31.7454 12.5 30.9091V9.09091C12.5 7.80451 13.8503 6.36364 15.0994 6.36364ZM14.4176 8.40909C14.0927 8.47035 13.8583 8.75799 13.8636 9.09091V30.2273C13.8636 30.6028 14.1699 30.9091 14.5454 30.9091H25.4545C25.8301 30.9091 26.1364 30.6028 26.1364 30.2273V9.09091C26.1364 8.71538 25.8301 8.40909 25.4545 8.40909H14.5454C14.5241 8.40909 14.5028 8.40909 14.4815 8.40909C14.4602 8.40909 14.4389 8.40909 14.4176 8.40909ZM15.2273 9.77273H24.7727V29.5455H15.2273V9.77273ZM20 31.25C19.4354 31.25 18.9773 31.7081 18.9773 32.2727C18.9773 32.8374 19.4354 33.2955 20 33.2955C20.5646 33.2955 21.0227 32.8374 21.0227 32.2727C21.0227 31.7081 20.5646 31.25 20 31.25Z" fill="#111111"/>
            </svg>
          </button>

          <button class="device" :class="{'active' : previewDevice === 2}" @click="previewDevice = 2">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M4.80005 35.2C4.80005 36.6906 5.53755 37.9125 6.47505 38.725C7.41255 39.5375 8.5438 40 9.60005 40L30.7 40C33.1719 40 35.2 37.9719 35.2 35.5L35.2 4.5C35.2 2.02812 33.1719 -1.24017e-06 30.7 -1.13212e-06L9.47505 -2.04351e-07C6.92505 -9.28867e-08 4.80005 2.28125 4.80005 4.8L4.80005 35.2ZM6.40005 35.2L6.40005 4.8C6.40005 3.24062 7.95005 1.6 9.47505 1.6L30.7 1.6C32.3063 1.6 33.6 2.89375 33.6 4.5L33.6 35.5C33.6 37.1094 32.3094 38.4 30.7 38.4L9.60005 38.4C9.0563 38.4 8.18755 38.0969 7.52505 37.525C6.86255 36.9531 6.40005 36.1719 6.40005 35.2ZM8.00005 34.55C8.07192 34.9312 8.40942 35.2062 8.80005 35.2L31.2 35.2C31.6407 35.2 32 34.8406 32 34.4L32 4.8C32 4.35937 31.6407 4 31.2 4L8.80005 4C8.35942 4 8.00005 4.35937 8.00005 4.8L8.00005 34.4C8.00005 34.425 8.00005 34.45 8.00005 34.475C8.00005 34.5 8.00005 34.525 8.00005 34.55ZM9.60005 33.6L9.60005 5.6L30.4 5.6L30.4 33.6L9.60005 33.6ZM18.8 36.8C18.8 37.4625 19.3375 38 20 38C20.6625 38 21.2 37.4625 21.2 36.8C21.2 36.1375 20.6625 35.6 20 35.6C19.3375 35.6 18.8 36.1375 18.8 36.8Z" fill="black"/>
            </svg>
          </button>

          <button class="device" :class="{'active' : previewDevice === 3}" @click="previewDevice = 3">
            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
              <path d="M2.64 4.40039C1.19281 4.40039 0 5.5932 0 7.04039V32.5604C0 34.0076 1.19281 35.2004 2.64 35.2004H17.9575L17.49 38.1704C17.3594 38.9954 16.6753 39.6004 15.84 39.6004H14.96C14.9325 39.6004 14.905 39.6004 14.8775 39.6004C14.3928 39.6245 14.0147 40.037 14.0387 40.5216C14.0628 41.0063 14.4753 41.3845 14.96 41.3604H29.04C29.3563 41.3638 29.6519 41.1988 29.8134 40.9238C29.9716 40.6488 29.9716 40.312 29.8134 40.037C29.6519 39.762 29.3563 39.597 29.04 39.6004H28.16C27.3247 39.6004 26.6406 38.9954 26.51 38.1704L26.0425 35.2004H41.36C42.8072 35.2004 44 34.0076 44 32.5604V7.04039C44 5.5932 42.8072 4.40039 41.36 4.40039H2.64ZM2.64 6.16039H41.36C41.8584 6.16039 42.24 6.54195 42.24 7.04039V28.1604H1.76V7.04039C1.76 6.54195 2.14156 6.16039 2.64 6.16039ZM1.76 29.9204H42.24V32.5604C42.24 33.0588 41.8584 33.4404 41.36 33.4404H2.64C2.14156 33.4404 1.76 33.0588 1.76 32.5604V29.9204ZM22 30.7179C21.4706 30.7179 21.0375 31.151 21.0375 31.6804C21.0375 32.2098 21.4706 32.6429 22 32.6429C22.5294 32.6429 22.9625 32.2098 22.9625 31.6804C22.9625 31.151 22.5294 30.7179 22 30.7179ZM19.7725 35.2004H24.2275L24.75 38.4454C24.8153 38.8613 24.9631 39.2498 25.1625 39.6004H18.8375C19.0369 39.2498 19.1847 38.8613 19.25 38.4454L19.7725 35.2004Z" fill="black"/>
            </svg>
          </button>
        </div>

        <button class="button-yellow medium-icon" @click="showSchedule = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <mask id="path-1-outside-1_5493_21016" maskUnits="userSpaceOnUse" x="2" y="2.18359" width="20" height="19" fill="black">
              <rect fill="white" x="2" y="2.18359" width="20" height="19"/>
              <path d="M8.14286 3.18359C7.44117 3.18359 6.76244 3.30126 6.12245 3.58251C5.99904 3.6313 5.91151 3.74466 5.89573 3.87811C5.87851 4.01156 5.93591 4.14214 6.04496 4.21963C6.15258 4.29855 6.29608 4.31146 6.41661 4.25407C6.95185 4.02017 7.52296 3.91829 8.14286 3.91829C10.5909 3.91829 12.551 5.87843 12.551 8.32645C12.551 10.7745 10.5909 12.7346 8.14286 12.7346C5.69483 12.7346 3.73469 10.7745 3.73469 8.32645C3.73469 7.21006 4.16231 6.21134 4.83673 5.41924V6.37923C4.8353 6.51124 4.90418 6.63465 5.01897 6.70209C5.13377 6.7681 5.27439 6.7681 5.38919 6.70209C5.50399 6.63465 5.57286 6.51124 5.57143 6.37923V4.28563H3.47784C3.34582 4.2842 3.22242 4.35308 3.15497 4.46787C3.08897 4.58267 3.08897 4.72329 3.15497 4.83809C3.22242 4.95289 3.34582 5.02176 3.47784 5.02033H4.20966C3.4721 5.92004 3 7.06083 3 8.32645C3 11.1691 5.30022 13.4693 8.14286 13.4693C10.9855 13.4693 13.2857 11.1691 13.2857 8.32645C13.2857 5.48382 10.9855 3.18359 8.14286 3.18359ZM16.9592 3.18359C16.5574 3.18359 16.2245 3.5165 16.2245 3.91829V4.65298H12.7232C12.9098 4.88401 13.0762 5.13082 13.2254 5.38768H16.2245V6.12237C16.2245 6.52415 16.5574 6.85706 16.9592 6.85706H17.6939C18.0957 6.85706 18.4286 6.52415 18.4286 6.12237V5.38768H20.2653V7.9591H14.0018C14.0089 8.08107 14.0204 8.20161 14.0204 8.32645C14.0204 8.45129 14.0089 8.57183 14.0018 8.6938H20.2653V20.0816H4.83673V13.1823C4.57414 13.0029 4.33163 12.8006 4.10204 12.5839V20.0816C4.10204 20.5077 4.41056 20.8162 4.83673 20.8162H20.2653C20.6915 20.8162 21 20.5077 21 20.0816V5.38768C21 4.9615 20.6915 4.65298 20.2653 4.65298H18.4286V3.91829C18.4286 3.5165 18.0957 3.18359 17.6939 3.18359H16.9592ZM16.9592 3.91829H17.6939V6.12237H16.9592V3.91829ZM8.13712 5.01459C7.93479 5.01889 7.77264 5.18535 7.77551 5.38768V8.26762C7.76403 8.34654 7.77695 8.4269 7.81569 8.49721C7.84869 8.56322 7.90179 8.61775 7.96636 8.65362L9.3927 9.72266C9.55485 9.84463 9.78444 9.81162 9.90641 9.64804C10.0284 9.48589 9.99538 9.2563 9.83179 9.13433L8.5102 8.14278V5.38768C8.51164 5.28866 8.4729 5.19252 8.40258 5.12221C8.33227 5.0519 8.23613 5.01315 8.13712 5.01459ZM13.7219 10.1632C13.6387 10.4172 13.5354 10.6611 13.4192 10.8979H14.7551V12.7346H12.1837V15.306H10.3469V13.7721C10.1102 13.8682 9.86336 13.9457 9.61225 14.0103V15.306H7.77551V14.1853C7.52583 14.1696 7.28045 14.1423 7.04082 14.0964V18.6122H18.0612V10.1632H13.7219ZM15.4898 10.8979H17.3265V12.7346H15.4898V10.8979ZM12.9184 13.4693H14.7551V15.306H12.9184V13.4693ZM15.4898 13.4693H17.3265V15.306H15.4898V13.4693ZM7.77551 16.0407H9.61225V17.8775H7.77551V16.0407ZM10.3469 16.0407H12.1837V17.8775H10.3469V16.0407ZM12.9184 16.0407H14.7551V17.8775H12.9184V16.0407ZM15.4898 16.0407H17.3265V17.8775H15.4898V16.0407Z"/>
            </mask>
            <path d="M8.14286 3.18359C7.44117 3.18359 6.76244 3.30126 6.12245 3.58251C5.99904 3.6313 5.91151 3.74466 5.89573 3.87811C5.87851 4.01156 5.93591 4.14214 6.04496 4.21963C6.15258 4.29855 6.29608 4.31146 6.41661 4.25407C6.95185 4.02017 7.52296 3.91829 8.14286 3.91829C10.5909 3.91829 12.551 5.87843 12.551 8.32645C12.551 10.7745 10.5909 12.7346 8.14286 12.7346C5.69483 12.7346 3.73469 10.7745 3.73469 8.32645C3.73469 7.21006 4.16231 6.21134 4.83673 5.41924V6.37923C4.8353 6.51124 4.90418 6.63465 5.01897 6.70209C5.13377 6.7681 5.27439 6.7681 5.38919 6.70209C5.50399 6.63465 5.57286 6.51124 5.57143 6.37923V4.28563H3.47784C3.34582 4.2842 3.22242 4.35308 3.15497 4.46787C3.08897 4.58267 3.08897 4.72329 3.15497 4.83809C3.22242 4.95289 3.34582 5.02176 3.47784 5.02033H4.20966C3.4721 5.92004 3 7.06083 3 8.32645C3 11.1691 5.30022 13.4693 8.14286 13.4693C10.9855 13.4693 13.2857 11.1691 13.2857 8.32645C13.2857 5.48382 10.9855 3.18359 8.14286 3.18359ZM16.9592 3.18359C16.5574 3.18359 16.2245 3.5165 16.2245 3.91829V4.65298H12.7232C12.9098 4.88401 13.0762 5.13082 13.2254 5.38768H16.2245V6.12237C16.2245 6.52415 16.5574 6.85706 16.9592 6.85706H17.6939C18.0957 6.85706 18.4286 6.52415 18.4286 6.12237V5.38768H20.2653V7.9591H14.0018C14.0089 8.08107 14.0204 8.20161 14.0204 8.32645C14.0204 8.45129 14.0089 8.57183 14.0018 8.6938H20.2653V20.0816H4.83673V13.1823C4.57414 13.0029 4.33163 12.8006 4.10204 12.5839V20.0816C4.10204 20.5077 4.41056 20.8162 4.83673 20.8162H20.2653C20.6915 20.8162 21 20.5077 21 20.0816V5.38768C21 4.9615 20.6915 4.65298 20.2653 4.65298H18.4286V3.91829C18.4286 3.5165 18.0957 3.18359 17.6939 3.18359H16.9592ZM16.9592 3.91829H17.6939V6.12237H16.9592V3.91829ZM8.13712 5.01459C7.93479 5.01889 7.77264 5.18535 7.77551 5.38768V8.26762C7.76403 8.34654 7.77695 8.4269 7.81569 8.49721C7.84869 8.56322 7.90179 8.61775 7.96636 8.65362L9.3927 9.72266C9.55485 9.84463 9.78444 9.81162 9.90641 9.64804C10.0284 9.48589 9.99538 9.2563 9.83179 9.13433L8.5102 8.14278V5.38768C8.51164 5.28866 8.4729 5.19252 8.40258 5.12221C8.33227 5.0519 8.23613 5.01315 8.13712 5.01459ZM13.7219 10.1632C13.6387 10.4172 13.5354 10.6611 13.4192 10.8979H14.7551V12.7346H12.1837V15.306H10.3469V13.7721C10.1102 13.8682 9.86336 13.9457 9.61225 14.0103V15.306H7.77551V14.1853C7.52583 14.1696 7.28045 14.1423 7.04082 14.0964V18.6122H18.0612V10.1632H13.7219ZM15.4898 10.8979H17.3265V12.7346H15.4898V10.8979ZM12.9184 13.4693H14.7551V15.306H12.9184V13.4693ZM15.4898 13.4693H17.3265V15.306H15.4898V13.4693ZM7.77551 16.0407H9.61225V17.8775H7.77551V16.0407ZM10.3469 16.0407H12.1837V17.8775H10.3469V16.0407ZM12.9184 16.0407H14.7551V17.8775H12.9184V16.0407ZM15.4898 16.0407H17.3265V17.8775H15.4898V16.0407Z" fill="#EA7801"/>
            <path d="M8.14286 3.18359C7.44117 3.18359 6.76244 3.30126 6.12245 3.58251C5.99904 3.6313 5.91151 3.74466 5.89573 3.87811C5.87851 4.01156 5.93591 4.14214 6.04496 4.21963C6.15258 4.29855 6.29608 4.31146 6.41661 4.25407C6.95185 4.02017 7.52296 3.91829 8.14286 3.91829C10.5909 3.91829 12.551 5.87843 12.551 8.32645C12.551 10.7745 10.5909 12.7346 8.14286 12.7346C5.69483 12.7346 3.73469 10.7745 3.73469 8.32645C3.73469 7.21006 4.16231 6.21134 4.83673 5.41924V6.37923C4.8353 6.51124 4.90418 6.63465 5.01897 6.70209C5.13377 6.7681 5.27439 6.7681 5.38919 6.70209C5.50399 6.63465 5.57286 6.51124 5.57143 6.37923V4.28563H3.47784C3.34582 4.2842 3.22242 4.35308 3.15497 4.46787C3.08897 4.58267 3.08897 4.72329 3.15497 4.83809C3.22242 4.95289 3.34582 5.02176 3.47784 5.02033H4.20966C3.4721 5.92004 3 7.06083 3 8.32645C3 11.1691 5.30022 13.4693 8.14286 13.4693C10.9855 13.4693 13.2857 11.1691 13.2857 8.32645C13.2857 5.48382 10.9855 3.18359 8.14286 3.18359ZM16.9592 3.18359C16.5574 3.18359 16.2245 3.5165 16.2245 3.91829V4.65298H12.7232C12.9098 4.88401 13.0762 5.13082 13.2254 5.38768H16.2245V6.12237C16.2245 6.52415 16.5574 6.85706 16.9592 6.85706H17.6939C18.0957 6.85706 18.4286 6.52415 18.4286 6.12237V5.38768H20.2653V7.9591H14.0018C14.0089 8.08107 14.0204 8.20161 14.0204 8.32645C14.0204 8.45129 14.0089 8.57183 14.0018 8.6938H20.2653V20.0816H4.83673V13.1823C4.57414 13.0029 4.33163 12.8006 4.10204 12.5839V20.0816C4.10204 20.5077 4.41056 20.8162 4.83673 20.8162H20.2653C20.6915 20.8162 21 20.5077 21 20.0816V5.38768C21 4.9615 20.6915 4.65298 20.2653 4.65298H18.4286V3.91829C18.4286 3.5165 18.0957 3.18359 17.6939 3.18359H16.9592ZM16.9592 3.91829H17.6939V6.12237H16.9592V3.91829ZM8.13712 5.01459C7.93479 5.01889 7.77264 5.18535 7.77551 5.38768V8.26762C7.76403 8.34654 7.77695 8.4269 7.81569 8.49721C7.84869 8.56322 7.90179 8.61775 7.96636 8.65362L9.3927 9.72266C9.55485 9.84463 9.78444 9.81162 9.90641 9.64804C10.0284 9.48589 9.99538 9.2563 9.83179 9.13433L8.5102 8.14278V5.38768C8.51164 5.28866 8.4729 5.19252 8.40258 5.12221C8.33227 5.0519 8.23613 5.01315 8.13712 5.01459ZM13.7219 10.1632C13.6387 10.4172 13.5354 10.6611 13.4192 10.8979H14.7551V12.7346H12.1837V15.306H10.3469V13.7721C10.1102 13.8682 9.86336 13.9457 9.61225 14.0103V15.306H7.77551V14.1853C7.52583 14.1696 7.28045 14.1423 7.04082 14.0964V18.6122H18.0612V10.1632H13.7219ZM15.4898 10.8979H17.3265V12.7346H15.4898V10.8979ZM12.9184 13.4693H14.7551V15.306H12.9184V13.4693ZM15.4898 13.4693H17.3265V15.306H15.4898V13.4693ZM7.77551 16.0407H9.61225V17.8775H7.77551V16.0407ZM10.3469 16.0407H12.1837V17.8775H10.3469V16.0407ZM12.9184 16.0407H14.7551V17.8775H12.9184V16.0407ZM15.4898 16.0407H17.3265V17.8775H15.4898V16.0407Z" stroke="#EA7801" stroke-width="0.6" mask="url(#path-1-outside-1_5493_21016)"/>
          </svg>
          Scheduling actions
        </button>

        <button class="button-yellow bookmark" @click="openFullscreenPreview">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M15.7928 9.28503L15.7945 9.283C15.9354 9.12097 15.9352 8.87894 15.7937 8.71722L15.7928 8.71616L15.7859 8.70814L15.7596 8.67791C15.7365 8.65166 15.7024 8.61352 15.6579 8.56517C15.5688 8.46849 15.4378 8.33093 15.2691 8.16614C14.9317 7.8367 14.4426 7.39759 13.8346 6.95829C12.6214 6.0817 10.9202 5.19375 9 5.19375C7.07979 5.19375 5.37864 6.0817 4.16542 6.95829C3.55743 7.39759 3.06826 7.8367 2.73092 8.16614C2.56217 8.33093 2.4312 8.46849 2.34214 8.56517C2.29761 8.61352 2.26354 8.65166 2.24044 8.67791L2.2141 8.70814L2.20722 8.71616L2.20548 8.71821C2.06455 8.88024 2.06484 9.12226 2.20634 9.28397L2.20722 9.28503L2.2141 9.29305L2.24044 9.32328C2.26354 9.34953 2.29761 9.38767 2.34214 9.43602C2.4312 9.5327 2.56217 9.67026 2.73092 9.83505C3.06826 10.1645 3.55743 10.6036 4.16542 11.0429C5.37864 11.9195 7.07979 12.8074 9 12.8074C10.9202 12.8074 12.6214 11.9195 13.8346 11.0429C14.4426 10.6036 14.9317 10.1645 15.2691 9.83505C15.4378 9.67026 15.5688 9.5327 15.6579 9.43602C15.7024 9.38767 15.7365 9.34953 15.7596 9.32328L15.7859 9.29305L15.7928 9.28503ZM9 6.05634C9.70512 6.05634 10.3819 6.19921 11.0138 6.42137C11.4158 6.88854 11.663 7.49193 11.663 8.15671C11.663 9.63088 10.4742 10.8197 9 10.8197C7.52583 10.8197 6.33704 9.63088 6.33704 8.15671C6.33704 7.49069 6.5766 6.88756 6.97748 6.42134C7.61134 6.19827 8.29243 6.05634 9 6.05634ZM3.13189 9.00073C3.49302 8.62536 4.41552 7.73884 5.66197 7.0353C5.54168 7.38739 5.47445 7.76468 5.47445 8.15671C5.47445 10.1009 7.05577 11.6823 9 11.6823C10.9442 11.6823 12.5255 10.1009 12.5255 8.15671C12.5255 7.76595 12.4611 7.38724 12.3431 7.03366C13.5875 7.73733 14.5069 8.62526 14.868 9.00079C14.568 9.3142 13.8815 9.9853 12.9404 10.6081C11.8773 11.3115 10.5021 11.9448 9 11.9448C7.49787 11.9448 6.12271 11.3115 5.05962 10.6081C4.11846 9.98526 3.43191 9.31412 3.13189 9.00073ZM9 6.60023C8.1403 6.60023 7.44352 7.29701 7.44352 8.15671C7.44352 9.01641 8.1403 9.71319 9 9.71319C9.8597 9.71319 10.5565 9.01641 10.5565 8.15671C10.5565 7.29701 9.8597 6.60023 9 6.60023Z" fill="#EA7801" stroke="#EA7801" stroke-width="0.3"/>
          </svg>
          Preview
        </button>

        <div class="publish-actions">
          <button :class="hasChanges ? 'button-solid publish' : 'button-solid publish disabled'" @click="saveActivation">
            <iconComponent symbol="floppyDisk" fill="#FFF" stroke="#FFF" :width="18"/>
            Save
          </button>
          <button class="button-solid drop-down" @click="showPublishMenu = !showPublishMenu">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M3.88227 7.04082L3.84691 7.00546L3.81155 7.04082L2.96464 7.88773L2.92929 7.92308L2.96464 7.95844L11.9646 16.9584L12 16.9938L12.0354 16.9584L21.0354 7.95844L21.0707 7.92308L21.0354 7.88773L20.1884 7.04082L20.1531 7.00546L20.1177 7.04082L12 15.1586L3.88227 7.04082Z" fill="white"/>
              <path d="M3.88227 7.04082L3.84691 7.00546L3.81155 7.04082L2.96464 7.88773L2.92929 7.92308L2.96464 7.95844L11.9646 16.9584L12 16.9938L12.0354 16.9584L21.0354 7.95844L21.0707 7.92308L21.0354 7.88773L20.1884 7.04082L20.1531 7.00546L20.1177 7.04082L12 15.1586L3.88227 7.04082Z" fill="url(#paint0_linear_6548_9779)"/>
              <path d="M3.88227 7.04082L3.84691 7.00546L3.81155 7.04082L2.96464 7.88773L2.92929 7.92308L2.96464 7.95844L11.9646 16.9584L12 16.9938L12.0354 16.9584L21.0354 7.95844L21.0707 7.92308L21.0354 7.88773L20.1884 7.04082L20.1531 7.00546L20.1177 7.04082L12 15.1586L3.88227 7.04082Z" stroke="white" stroke-width="0.1"/>
              <path d="M3.88227 7.04082L3.84691 7.00546L3.81155 7.04082L2.96464 7.88773L2.92929 7.92308L2.96464 7.95844L11.9646 16.9584L12 16.9938L12.0354 16.9584L21.0354 7.95844L21.0707 7.92308L21.0354 7.88773L20.1884 7.04082L20.1531 7.00546L20.1177 7.04082L12 15.1586L3.88227 7.04082Z" stroke="url(#paint1_linear_6548_9779)" stroke-width="0.1"/>
              <defs>
                <linearGradient id="paint0_linear_6548_9779" x1="12" y1="7.07617" x2="12" y2="16.9231" gradientUnits="userSpaceOnUse">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </linearGradient>
                <linearGradient id="paint1_linear_6548_9779" x1="12" y1="7.07617" x2="12" y2="16.9231" gradientUnits="userSpaceOnUse">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </linearGradient>
              </defs>
            </svg>
          </button>

          <div class="action-list">
            <div v-if="showPublishMenu" style="position: fixed; top: 0px; bottom: 0px; right: 0px; left: 0px;" @click="showPublishMenu = false" >
            </div>
            <div class="drop-down-container">
              <div @click="showPublishMenu = !showPublishMenu">
              </div>
              <div v-if="showPublishMenu" class="drop-down-buttons" >
                <div>
                  <div @click="publish(activation.public)"
                       class="drop-down-button clickable">
                    <iconComponent symbol="rocket" fill="#EA7801" stroke="#EA7801" :width="18"/>
                    Publish
                  </div>
                </div>

                <div>
                  <div @click="toggleBookmark"
                       class="drop-down-button clickable">
                    <iconComponent v-if="isBookMarked" symbol="bookmarkedFilled" :width="20" stroke="#EA7801" fill="#EA7801"/>
                    <iconComponent v-else symbol="bookmarked" stroke="#ea7801" fill="#EA7801" :width="20"/>
                    Bookmark
                  </div>
                </div>

                <div>
                  <div v-if="unPublishAllowed" @click="unPublish" class="drop-down-button clickable">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                      <path d="M28.1546 4.34539L28.1499 4.50441L28.1347 5.02346L28.1347 5.02365L28.1346 5.02428L28.1346 5.02482L28.1346 5.02652L28.1344 5.03489L28.1334 5.06692C28.1324 5.09494 28.1308 5.13616 28.1281 5.18967C28.1227 5.29668 28.1131 5.45284 28.0962 5.65083C28.0624 6.04676 27.9993 6.61024 27.8821 7.28254C27.6478 8.62627 27.1967 10.4091 26.3282 12.1585L26.3281 12.1587C25.7653 13.2883 25.0044 14.4252 23.9888 15.4427L23.9887 15.4428C22.7795 16.652 20.7501 18.3856 18.8286 19.9836V24.1071C18.8286 24.3015 18.7413 24.4837 18.5899 24.6059C18.5896 24.6062 18.5892 24.6065 18.5888 24.6067L15.6522 27.054L15.6494 27.0563L15.6494 27.0562C15.4809 27.1901 15.254 27.2335 15.0473 27.1633C14.8415 27.0952 14.685 26.9252 14.6304 26.7166L14.6301 26.7153L13.936 23.9673L13.9255 23.9753L13.9202 23.9794L13.9199 23.9796L13.9185 23.9808L13.9181 23.981L13.918 23.9811L13.918 23.9811L13.8437 24.0406L13.8228 24.0573L13.7974 24.0658L13.7056 24.0964L13.6939 24.1003L13.6582 23.9541L13.6937 24.0998L13.6937 24.0998L13.6936 24.0998L13.6933 24.0999L13.6926 24.1001L13.6905 24.1006L13.6833 24.1022C13.681 24.1028 13.6783 24.1033 13.6752 24.104C13.6704 24.105 13.6647 24.1062 13.6583 24.1075C13.6373 24.1118 13.6078 24.1172 13.5727 24.1222C13.5038 24.132 13.408 24.1411 13.3111 24.1343C13.3111 24.1343 13.311 24.1343 13.311 24.1343L13.3214 23.9847C13.2659 23.9809 13.1894 23.9675 13.1224 23.9541L28.1546 4.34539ZM28.1546 4.34539L27.9956 4.35006L27.4775 4.36532L27.4773 4.36532L27.4767 4.36533L27.4763 4.36534L27.4744 4.36537L27.4661 4.36553L27.4341 4.36633C27.4061 4.36712 27.3649 4.36851 27.3114 4.37088C27.2045 4.37564 27.0485 4.38436 26.8507 4.40026C26.4552 4.43204 25.8921 4.49251 25.2201 4.60732C23.8769 4.83681 22.0938 5.28415 20.3413 6.15653L20.3412 6.15661C19.2128 6.71984 18.0781 7.49233 17.0573 8.51118L17.0572 8.51128C15.8217 9.74676 14.0864 11.7627 12.501 13.6714M28.1546 4.34539L12.501 13.6714M12.501 13.6714H8.39286H8.39277H8.39268H8.39259H8.3925H8.39241H8.39232H8.39223H8.39214H8.39205H8.39196H8.39187H8.39178H8.39169H8.3916H8.39151H8.39142H8.39133H8.39124H8.39115H8.39106H8.39097H8.39088H8.39079H8.3907H8.39061H8.39053H8.39044H8.39035H8.39026H8.39017H8.39008H8.38999H8.3899H8.38981H8.38972H8.38963H8.38954H8.38945H8.38936H8.38927H8.38918H8.38909H8.389H8.38891H8.38882H8.38873H8.38864H8.38855H8.38846H8.38837H8.38828H8.38819H8.3881H8.38801H8.38792H8.38784H8.38774H8.38766H8.38757H8.38748H8.38739H8.3873H8.38721H8.38712H8.38703H8.38694H8.38685H8.38676H8.38667H8.38658H8.38649H8.3864H8.38631H8.38622H8.38613H8.38604H8.38595H8.38586H8.38577H8.38568H8.38559H8.3855H8.38541H8.38532H8.38523H8.38514H8.38505H8.38496H8.38488H8.38479H8.3847H8.38461H8.38452H8.38443H8.38434H8.38425H8.38416H8.38407H8.38398H8.38389H8.3838H8.38371H8.38362H8.38353H8.38344H8.38335H8.38326H8.38317H8.38308H8.38299H8.3829H8.38281H8.38272H8.38263H8.38254H8.38245H8.38236H8.38227H8.38218H8.38209H8.38201H8.38192H8.38183H8.38174H8.38165H8.38156H8.38147H8.38138H8.38129H8.3812H8.38111H8.38102H8.38093H8.38084H8.38075H8.38066H8.38057H8.38048H8.38039H8.3803H8.38021H8.38012H8.38003H8.37994H8.37985H8.37976H8.37967H8.37958H8.37949H8.3794H8.37931H8.37923H8.37914H8.37905H8.37896H8.37887H8.37878H8.37869H8.3786H8.37851H8.37842H8.37833H8.37824H8.37815H8.37806H8.37797H8.37788H8.37779H8.3777H8.37761H8.37752H8.37743H8.37734H8.37725H8.37716H8.37707H8.37698H8.37689H8.3768H8.37671H8.37662H8.37653H8.37644H8.37636H8.37627H8.37618H8.37609H8.376H8.37591H8.37582H8.37573H8.37564H8.37555H8.37546H8.37537H8.37528H8.37519H8.3751H8.37501H8.37492H8.37483H8.37474H8.37465H8.37456H8.37447H8.37438H8.37429H8.3742H8.37411H8.37402H8.37393H8.37384H8.37375H8.37366H8.37358H8.37349H8.3734H8.37331H8.37322H8.37313H8.37304H8.37295H8.37286H8.37277H8.37268H8.37259H8.3725H8.37241H8.37232H8.37223H8.37214H8.37205H8.37196H8.37187H8.37178H8.37169H8.3716H8.37151H8.37142H8.37133H8.37124H8.37115H8.37106H8.37097H8.37088H8.37079H8.37071H8.37062H8.37053H8.37044H8.37035H8.37026H8.37017H8.37008H8.36999H8.3699H8.36981H8.36972H8.36963H8.36954H8.36945H8.36936H8.36927H8.36918H8.36909H8.369H8.36891H8.36882H8.36873H8.36864H8.36855H8.36846H8.36837H8.36828H8.36819H8.3681H8.36801H8.36793H8.36784H8.36775H8.36766H8.36757H8.36748H8.36739H8.3673H8.36721H8.36712H8.36703H8.36694H8.36685H8.36676H8.36667H8.36658H8.36649H8.3664H8.36631H8.36622H8.36613H8.36604H8.36595H8.36586H8.36577H8.36568H8.36559H8.3655H8.36541H8.36532H8.36523H8.36514H8.36506H8.36497H8.36488H8.36479H8.3647H8.36461H8.36452H8.36443H8.36434H8.36425H8.36416H8.36407H8.36398H8.36389H8.3638H8.36371H8.36362H8.36353H8.36344H8.36335H8.36326H8.36317H8.36308H8.36299H8.3629H8.36281H8.36272H8.36263H8.36254H8.36245H8.36236H8.36227H8.36219H8.3621H8.36201H8.36192H8.36183H8.36174H8.36165H8.36156H8.36147H8.36138H8.36129H8.3612H8.36111H8.36102H8.36093H8.36084H8.36075H8.36066H8.36057H8.36048H8.36039H8.3603H8.36021H8.36012H8.36003H8.35994H8.35985H8.35976H8.35967H8.35958H8.35949H8.35941H8.35932H8.35923H8.35914H8.35905H8.35896H8.35887H8.35878H8.35869H8.3586H8.35851H8.35842H8.35833H8.35824H8.35815H8.35806H8.35797H8.35788H8.35779H8.3577H8.35761H8.35752H8.35743H8.35734H8.35725H8.35716H8.35707H8.35698H8.35689H8.3568H8.35671H8.35662H8.35653H8.35645H8.35636H8.35627H8.35618H8.35609H8.356H8.35591H8.35582H8.35573H8.35564H8.35555H8.35546H8.35537H8.35528H8.35519H8.3551H8.35501H8.35492H8.35483H8.35474H8.35465H8.35456H8.35447H8.35438H8.35429H8.3542H8.35411H8.35402H8.35393H8.35384H8.35375H8.35366H8.35358H8.35349H8.3534H8.35331H8.35322H8.35313H8.35304H8.35295H8.35286H8.35277H8.35268H8.35259H8.3525H8.35241H8.35232H8.35223H8.35214H8.35205H8.35196H8.35187H8.35178H8.35169H8.3516H8.35151H8.35142H8.35133H8.35124H8.35115H8.35106H8.35097H8.35088H8.3508H8.35071H8.35062H8.35053H8.35044H8.35035H8.35026H8.35017H8.35008H8.34999H8.3499H8.34981H8.34972H8.34963H8.34954H8.34945H8.34936H8.34927H8.34918H8.34909H8.349H8.34891H8.34882H8.34873H8.34864H8.34855H8.34846H8.34837H8.34828H8.34819H8.3481H8.34801H8.34793H8.34784H8.34775H8.34766H8.34757H8.34748H8.34739H8.3473H8.34721H8.34712H8.34703H8.34694H8.33935L8.3318 13.6722C8.16163 13.6895 8.00201 13.7732 7.89357 13.9108L5.44599 16.8478L5.44596 16.8478L5.44376 16.8506C5.30995 17.0191 5.26647 17.246 5.33674 17.4527C5.40481 17.6585 5.57478 17.815 5.78342 17.8696L5.78487 17.87L8.54528 18.5636L8.54278 18.5668L8.52598 18.5882L8.52528 18.5891L8.47046 18.6439L8.44543 18.669L8.43423 18.7026L8.40362 18.7944L8.40314 18.7942L8.40021 18.8062L8.54592 18.8418L8.4002 18.8063L8.40019 18.8063L8.40016 18.8064L8.4001 18.8067L8.39993 18.8074L8.39942 18.8095L8.39777 18.8167C8.39642 18.8227 8.39459 18.8312 8.39247 18.8417C8.38824 18.8627 8.38283 18.8922 8.37782 18.9273C8.36798 18.9961 8.35894 19.0917 8.36563 19.1885C8.36564 19.1886 8.36566 19.1888 8.36567 19.189L8.51531 19.1786C8.51913 19.2398 8.53061 19.3202 8.54592 19.3929M12.501 13.6714L7.36088 21.0917L7.36053 21.0915L7.35563 21.1013L7.4898 21.1684L8.54592 19.3929M8.54592 19.3929L8.417 19.3162L8.38782 19.3652C8.39132 19.385 8.39512 19.4047 8.39914 19.4238L8.54592 19.3929ZM11.4078 25.1394L13.1499 24.1121L8.83673 23.6633C9.60969 24.4343 10.1091 24.7959 10.4898 24.9643L10.4289 25.1014C10.429 25.1014 10.429 25.1014 10.4291 25.1015C10.6335 25.1923 10.8115 25.2322 10.9755 25.2367C11.0523 25.2388 11.1375 25.235 11.2127 25.2175C11.256 25.2074 11.3054 25.187 11.3369 25.1732C11.3541 25.1656 11.3693 25.1585 11.3802 25.1533L11.3933 25.147L11.3971 25.1452L11.3982 25.1446L11.3985 25.1445L11.3986 25.1444L11.3987 25.1444L11.3987 25.1444L11.3989 25.1447L11.4078 25.1394ZM13.1028 22.7745L13.1026 22.7744C12.7619 22.6353 12.1372 22.2669 11.1928 21.3225C10.248 20.3777 9.86461 19.7378 9.7256 19.3974L9.72554 19.3972C9.68731 19.3039 9.67297 19.2402 9.6661 19.1927C9.93883 18.849 11.4657 16.9298 13.2293 14.8001C13.2881 14.7495 13.3344 14.6901 13.3701 14.6248C14.973 12.6916 16.7436 10.6267 17.9581 9.41219C18.8671 8.50321 19.8787 7.82533 20.9035 7.31288C23.4978 6.02285 25.8877 5.77382 26.7839 5.71571C26.7239 6.61358 26.472 9.00546 25.187 11.5966C24.6767 12.623 23.9932 13.6365 23.0878 14.5419C21.9012 15.7285 19.8096 17.512 17.8555 19.1335C17.8104 19.1625 17.7684 19.1977 17.7315 19.2394C15.5934 21.0111 13.6527 22.5593 13.3072 22.8339C13.2597 22.827 13.1961 22.8127 13.1028 22.7745ZM10.9479 23.9238C10.7722 23.8468 10.3496 23.5846 9.63144 22.8683C8.91537 22.1503 8.65317 21.7278 8.57618 21.552L8.57533 21.5502C8.57514 21.5498 8.57496 21.5494 8.57478 21.549L9.04142 20.7636C9.32071 21.177 9.70798 21.6548 10.2766 22.2234C10.8436 22.7904 11.3226 23.1789 11.7364 23.4586L10.951 23.9252C10.9506 23.925 10.9502 23.9248 10.9498 23.9247L10.9479 23.9238ZM7.24187 22.6541L7.15065 22.5341L7.03109 22.6259C6.67942 22.896 6.34409 23.0583 6.01027 23.2199C5.9782 23.2354 5.94615 23.2509 5.9141 23.2665C5.54999 23.4438 5.18761 23.6318 4.84386 23.9695C4.49537 24.3119 4.22513 24.7917 4.06856 25.4339C3.91309 26.0715 3.85 26.8856 3.85 28.0102V28.5V28.65H4H4.4898C6.74683 28.65 7.90166 28.2952 8.60683 27.5798C8.95434 27.2272 9.15518 26.8555 9.32971 26.4958C9.35871 26.436 9.38687 26.3769 9.41474 26.3183C9.55632 26.021 9.69054 25.7391 9.89122 25.4665L9.98043 25.3452L9.85891 25.2564L9.06299 24.6748L8.94218 24.5865L8.8536 24.7071C8.52732 25.1513 8.32814 25.5576 8.16285 25.8965C7.99443 26.2419 7.86915 26.4978 7.6891 26.6804L7.689 26.6805C7.53789 26.8341 7.2807 26.9803 6.84976 27.0957C6.44892 27.203 5.90742 27.2811 5.18131 27.3173C5.20605 26.663 5.24179 26.0697 5.32419 25.735C5.44181 25.259 5.58 25.0472 5.74272 24.8878L5.743 24.8875C5.89668 24.7362 6.1216 24.6211 6.44035 24.458C6.46577 24.445 6.49178 24.4317 6.5184 24.4181C6.87063 24.2374 7.30343 24.0067 7.7954 23.6292L7.91385 23.5383L7.82351 23.4194L7.24187 22.6541ZM20.6378 9.26327C19.208 9.26327 18.0388 10.4325 18.0388 11.8622C18.0388 13.292 19.208 14.4612 20.6378 14.4612C22.0675 14.4612 23.2367 13.292 23.2367 11.8622C23.2367 10.4325 22.0675 9.26327 20.6378 9.26327ZM20.6378 10.5429C21.3719 10.5429 21.9571 11.1281 21.9571 11.8622C21.9571 12.5964 21.3719 13.1816 20.6378 13.1816C19.9036 13.1816 19.3184 12.5964 19.3184 11.8622C19.3184 11.1281 19.9036 10.5429 20.6378 10.5429ZM7.08463 16.8723L8.69251 14.951H11.4437C10.7126 15.8463 10.0893 16.6277 9.59386 17.2489C9.53497 17.3228 9.4779 17.3943 9.42266 17.4635L7.08463 16.8723ZM15.0365 23.0924C15.6869 22.5716 16.539 21.8863 17.549 21.0573V23.8075L15.6274 25.4156L15.0365 23.0924Z" fill="#EA7801" stroke="#EA7801" stroke-width="0.3"/>
                    </svg>
                    Unpublish
                  </div>
                </div>

                <div @click="deleteActivation"
                     class="drop-down-button clickable no-border">
                  <iconComponent symbol="trashcan" :width="20" stroke="#ea7801" fill="#ea7801" />
                  <div>
                    Delete
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activationIsSupported" class="content-container">
      <div class="activation-preview-container">
        <div class="activation-steps">
          <ActivationModuleIcon
            v-for="(stepConfiguration, index) in activationSteps"
            v-bind="getStepIconAttributes(stepConfiguration)"
            :key="stepConfiguration"
            :completed="index < selectedStepIndex"
            :selected="index === selectedStepIndex"
            @click="selectedStepIndex = index;"
          />
        </div>
        <div class="preview">
          <PreviewComponent v-bind="previewDimensions">
            <component
              :is="this.previewModel"
              :preview="true"
              :authenticated="true"
              :scrolling="true"
              :previewWidth="previewDimensions.width"
              :previewHeight="previewDimensions.height * previewDimensions.zoom"
              v-bind="this.previewOptions">
            </component>
          </PreviewComponent>
        </div>
      </div>
      <div class="activation-edit-container">
        <PropertyBox :title="stepName" :description="`Step ${selectedStepIndex+1} of ${activationSteps.length}`" :showDeleteButton="isDeleteAble(selectedStepIndex)"
                     :buttonText="nextButtonText" @next="nextStep" @delete="deleteStep(selectedStepIndex)">
          <component :is="activationSteps[selectedStepIndex]" :activation="activation" @changeData="changeActivityData"></component>
        </PropertyBox>
      </div>
    </div>
    <div v-else>
      <p>{{ error ? error : 'Activation is not supported :(' }}</p>
    </div>

    <PartnerModal :show="showSchedule" :showCloseButton="false" @close="showSchedule = false">
      <ActivationScheduling :actions="this.pv?.cta_actions" @saveActions="handleSavedScheduledActions" @closeActionsModal="showSchedule = false;"/>
    </PartnerModal>

    <ActivationPublish
      :activation="activation"
      :show="showPublishDetails"
      @published="setAsPublished"
      @close="showPublishDetails = false"
    />

    <UnsavedChanges
      :show="showUnsavedChanges"
      @save="saveActivation(); showUnsavedChanges = false; $router.go(-1);"
      @close="showUnsavedChanges = false;"
    />

  </div>
</template>

<script>
import axios from "axios";
import PartnerMixin from "@/mixins/PartnerMixin.vue";
import PreviewComponent from '@/stories/components/PreviewComponent/PreviewComponent.vue';
import ActivationView from "@/stories/components/ActivationView/ActivationView.vue";
import PVView from "@/stories/components/PVView/PVView.vue";
import PropertyBox from '@/stories/components/PropertyBox/PropertyBox.vue';
import ActivationModuleIcon from "@/stories/components/ActivationModuleIcon/ActivationModuleIcon.vue";
import PartnerModal from "@/stories/components/PartnerModal/PartnerModal.vue";
import ActivationPublish from "@/stories/components/ActivationPublish/ActivationPublish.vue";
import ActivationScheduling from "@/stories/components/ActivationScheduling/ActivationScheduling.vue";
import DateTimeConverterMixin from "@/mixins/DateTimeConverterMixin.vue";
import {mapGetters} from "vuex";
import UnsavedChanges from "@/stories/components/UnsavedChanges/UnsavedChanges.vue";
import svgMixin from "@/mixins/SvgMixin.vue";

export default {
  name: "PartnerActivation",
  components: {
    UnsavedChanges,
    ActivationPublish,
    ActivationView,
    PreviewComponent,
    PropertyBox,
    PVView,
    PartnerModal,
    ActivationModuleIcon,
    ActivationScheduling,
},
  mixins: [PartnerMixin, DateTimeConverterMixin, svgMixin],
  props: {
    activationId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      loading: false,
      goodiebag: null,
      offer: null,
      pv: null,
      subOffer: null,
      selectedStepIndex: 0,
      previewDevice: 1,
      editActivation: {},
      editOffer: {},
      editSubOffer: {},
      offerUploads: {},
      activationUploads: {},
      showSchedule: false,
      showPublishMenu: false,
      showPublishDetails: false,
      showUnsavedChanges: false,
    }
  },
  methods: {
    async getGoodiebag() {
      const goodiebagId = this.offer?.goodiebag?._id || this.offer?.goodiebag;
      if (!goodiebagId) {
        throw new Error('Goodiebag ID is required');
      }

      const response = await axios.get(`/api/c/goodiebags/${goodiebagId}`);
      this.goodiebag = response.data.goodiebag;
    },
    async getData() {
      try {
        this.loading = true;
        const response = await axios.get(`/api/c/companies/activations/${this.activationId}`);
        this.offer = response.data.offer;
        this.pv = response.data.activation;
        this.subOffer = response.data.subOffer;

        //this.$set(this.editOffer, 'media', { ...this.offer.media } ?? []);

        await this.getGoodiebag();

        this.activationSteps = this.getActivationSteps(this.offer, this.pv, this.subOffer);
        this.selectedStepIndex = 0;

      } catch (error) {
        this.error = error.message ?? 'Failed to load data';
      } finally {
        this.loading = false;
      }
    },
    copyChangesToSubOffer() {
      if (!this.subOffer) {
        return;
      }

      const keysToCheck = ['media', 'media', 'icon', 'icon', 'banner', 'banner', 'thumbnail', 'thumbnail'];
      keysToCheck.forEach(key => {
        try {
          if (
            (this.offer[key] && !this.subOffer[key]) ||
            (!this.offer[key] && this.subOffer[key]) ||
            (
              (this.offer[key] && this.subOffer[key]) &&
              JSON.stringify(this.offer[key]) !== JSON.stringify(this.subOffer[key])
            )
          ) {
            this.editSubOffer[key] = this.offer[key];
          }
        } catch (error) {
          console.log('Failed to copy ' + key, error);
        }
      });
    },
    async updateChangedOffer() {
      try {
        const response = await this.updateOffer(this.offer._id, this.editOffer, this.offerUploads);
        // Update the offer with the changed data and clear the stored changes
        this.offer = { ...this.offer, ...response.data?.offer }
        this.editOffer = {}
        this.offerUploads = {}

        this.copyChangesToSubOffer();
      } catch (error) {
        this.setAlert('Failed to update offer', 1);
        throw error;
      }
    },
    async updateChangedActivation() {
      try {
        const response = await this.updateActivation(this.activationId, this.editActivation, this.activationUploads);
        // Update activation with the new data and clear the changes
        this.pv = { ...this.pv, ...response.data?.activation }
        this.editActivation = {}
        this.activationUploads = {}

      } catch (error) {
        this.setAlert('Failed to update activation', 1);
        throw error;
      }
    },
    async updateSubOffer() {
      try {
        const formData = new FormData();
        formData.append('offer', JSON.stringify(this.editSubOffer));
        const response = await axios.put(`/api/c/companies/activations/${this.subOffer?._id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

        // Update the offer with the changed data and clear the stored changes
        this.subOffer = { ...this.subOffer, ...response.data?.offer }
        this.editSubOffer = {}

      } catch (error) {
        this.setAlert('Failed to update suboffer', 1);
        throw error;
      }
    },
    async validateUniqueName() {
      if (!this.editOffer.unique_name)
        return true;

      try {
        const response = await axios.get(`/api/c/companies/activations/unique/${this.editOffer.unique_name}`);

        if (!response.data.isUnique)
            this.setAlert(`You need to set a unique name for this activation!`);

        return response.isUnique;
      } catch (error) {
        return false;
      }
    },
    async saveActivation() {

      if (!this.hasChanges)
          return;

      if (!(await this.validateUniqueName())) {
          this.showPublishMenu = false;
          return;
      }

      try {
        if (Object.keys(this.editOffer).length + Object.keys(this.offerUploads).length > 0) {
          await this.updateChangedOffer();
        }
        if (this.pv && (Object.keys(this.editActivation).length + Object.keys(this.activationUploads).length > 0)) {
          await this.updateChangedActivation();
        }
        if (this.subOffer && Object.keys(this.editSubOffer).length > 0) {
          await this.updateSubOffer();
        }
        this.setAlert('Changes saved')
        this.showPublishMenu = false;
      } catch (error) {
        this.setAlert('Failed to save changes', 1);
      }
    },
    async toggleBookmark() {
      await this.$store.dispatch('bookmarkCompanyOffer', { entityId: this.activationId, entityType: 'offer' })

      if (this.user.bookmarked_offers.includes(this.activationId))
        this.setAlert(`Successfully bookmarked the collection!`);
      else
        this.setAlert(`Successfully removed the bookmarked collection!`);

      this.showPublishMenu = false;
    },
    async unPublish() {
      await this.unPublishOffer(this.activationId);

      if (this.activation.pvActivationId)
        await this.unPublishActivation(this.activationId);

      this.showPublishMenu = false;

      await this.getData(); // refresh offer and activation.
    },
    deleteActivation(activation) {
      this.setAlert("Delete is not implemented yet");
      this.showPublishMenu = false;
    },
    goToCollection() {
      if (!this.offer.goodiebag?._id)
        return;

      this.$router.push({ name: 'PartnerCollection', params: { collectionId: this.offer.goodiebag._id } });
    },
    setOfferUploadData(key, data) {
      if (data && Object.keys(data).length > 0) {
        this.offerUploads = { ...this.offerUploads, [key]: data }
      } else {
        this.offerUploads[key] = null;
      }
    },
    setActivationUploadData(key, data) {
      const feKey = `fe_${key}`;
      if (data) {
        this.activationUploads = { ...this.activationUploads, [key]: data };
        delete this.editActivation[key];
        delete this.editActivation[feKey];
      } else {
        delete this.activationUploads[key];
        delete this.activationUploads[feKey];
      }
    },
    changeActivityData(data) {

      if (data === undefined)
        return;

      const dataKeys = Object.keys(data);

      if (this.currentType === 'ActivationStepConfig') {
        if (dataKeys.includes('media')) {
          let imageObjects = [];
          this.editOffer = { ...this.editOffer, ...data };

          data.media.forEach((image, index) => {
            if (image?.fileObject) {
              imageObjects.push(image.fileObject);
            } else {
              this.editOffer = { ...this.editOffer, ...data };
            }
          });

          if (imageObjects.length > 0)
            this.setOfferUploadData('media', imageObjects);

        } else if (dataKeys.includes('thumbnail')) {
          if (data.thumbnail?.fileObject) {
            this.setOfferUploadData('thumbnail', data.thumbnail?.fileObject);
          } else {
            this.setOfferUploadData('thumbnail', null);
            data.thumbnail = null;
            this.editOffer = { ...this.editOffer, ...data };
          }

        } else if (dataKeys.includes('banner')) {
          if (data.banner?.fileObject) {
            this.setOfferUploadData('banner', data.banner?.fileObject);
          } else {
            this.setOfferUploadData('banner', null);
            data.banner = null;
            this.editOffer = { ...this.editOffer, ...data };
          }

        } else if (dataKeys.includes('icon')) {
          if (data.icon?.fileObject) {
            this.setOfferUploadData('icon', data.icon?.fileObject);
          } else {
            this.setOfferUploadData('icon', null);
            data.icon = null;
            this.editOffer = { ...this.editOffer, ...data };
          }

        } else {
          this.editOffer = {
            ...this.editOffer,
            ...data,
          }
        }

      } else if (this.currentType === 'ReturnSurveyStepConfig') {
        if (dataKeys.includes('cta_actions')) {
          this.editActivation = { ...this.editActivation, ...data }
        } else {
          this.editSubOffer = { ...this.editSubOffer, ...data }
        }

      } else {
        if (dataKeys.includes('fe_media')) {
          if (data.fe_media?.fileObject) {
            this.setActivationUploadData('media', data.fe_media.fileObject);
          } else {
            this.setActivationUploadData('media', null);
            this.editActivation = { ...this.editActivation, ...data, media: {} };
          }

        } else if (dataKeys.includes('fe_icon')) {
          if (data.fe_icon?.fileObject) {
            this.setActivationUploadData('icon', data.fe_icon.fileObject);
          } else {
            this.setActivationUploadData('icon', null);
            this.editActivation = { ...this.editActivation, ...data, icon: null };
          }

        } else {
          this.editActivation = {
            ...this.editActivation,
            ...data,
          }
        }
      }
    },
    nextStep() {
      this.selectedStepIndex += 1
    },
    deleteStep(selectedStepIndex) {
      if (this.activationSteps[selectedStepIndex] === 'AddressSurveyStepConfig') {
        this.$set(this.editActivation, 'address_step', false);//todo: temporary solution, should be handled better in the future
        this.activationSteps.splice(selectedStepIndex, 1);
      }
    },
    getStepIconAttributes(step) {
      switch (step) {
        case 'ActivationStepConfig':
          return {
            icon: require('../stories/assets/module-icon-activation.png'),
            title: 'Activation page'
          }
        case 'TermsStepConfig':
          return {
            icon: require('../stories/assets/module-icon-terms.png'),
            title: 'Terms'
          }
        case 'StyleDetailsStepConfig':
          return {
            icon: require('../stories/assets/module-icon-style.png'),
            title: 'Style details'
          }
        case 'ReceiptStepConfig':
          return {
            icon: require('../stories/assets/module-icon-receipt.png'),
            title: 'Receipt registration'
          }
        case 'ProductRegistrationStepConfig':
          return {
            icon: require('../stories/assets/module-icon-product.png'),
            title: 'Product registration'
          }
        case 'SurveyStepConfig':
          return {
            icon: require('../stories/assets/module-icon-survey.png'),
            title: 'Survey'
          }
        case 'AddressSurveyStepConfig':
          return {
            icon: require('../stories/assets/module-icon-address-survey.png'),
            title: 'Address survey'
          }
        case 'CashbackStepConfig':
          return {
            icon: require('../stories/assets/module-icon-cashback.png'),
            title: 'Cashback'
          }
        case 'ConfirmationStepConfig':
          return {
            icon: require('../stories/assets/module-icon-confirm.png'),
            title: 'Confirm message'
          }
        case 'EmailConfirmationStepConfig':
          return {
            icon: require('../stories/assets/module-icon-email.png'),
            title: 'Email'
          }
        case 'ReturnSurveyStepConfig':
          return {
            icon: require('../stories/assets/module-icon-return.png'),
            title: 'Return survey',
            badge: 'schedule',
          }
        default: {
          return {
            icon: '',
            title: 'Unknown'
          }
        }
      }
    },
    openFullscreenPreview() {
      if (this.offer.external_link === undefined || this.offer.external_link.length === 0)
        return;

      window.open(this.offer.external_link, '_blank', 'noreferrer');
    },
    publish(state) {
      if (state === 'Published')
        return;

      this.showPublishDetails = true;
    },
    async setAsPublished(activationDate) {
      this.showPublishDetails = false;

      await this.getData(); // refresh offer and activation.
    },
    handleSavedScheduledActions(actions) {
      this.showSchedule = false;
      this.editActivation.cta_actions = actions;

      try {
        this.updateChangedActivation();
      } catch (error) {
        this.setAlert('Could not save actions, an error occurred', 1);
        return;
      }
      this.setAlert('Successfully saved actions!', 1);
    },
    onExit() {
      if (this.hasChanges) {
          this.showUnsavedChanges = true;
          return;
      }

      this.$router.go(-1);
    },
    isDeleteAble(selectedStepIndex) {
      return this.activationSteps[selectedStepIndex] === 'AddressSurveyStepConfig'; // todo: temporary solution, should be handled better in the future
    }
  },
  computed: {
    ...mapGetters(['user']),
    currentType() {
      return this.activationSteps[this.selectedStepIndex] ?? ''
    },
    // ToDo:
    isEditingOffer() {
      return ['ActivationStepConfig', 'ReturnSurveyStepConfig'].includes(this.currentType);
    },
    isEditingSubOffer() {
      return this.currentType === 'ReturnSurveyStepConfig';
    },
    activation() {
      const currentOffer = this.isEditingSubOffer ? this.subOffer : this.offer;
      const currentEditOffer = this.isEditingSubOffer ? this.editSubOffer : this.editOffer;

      // Select image data to be passed to the various StepConfig components
      const parsedData = this.isEditingOffer
        ? {
          media: this.offerUploads.media ? [{ fileObject: this.offerUploads.media }] : (this.offer.media || []),
          banner: this.offerUploads.banner ? { fileObject: this.offerUploads.banner } : this.offer.banner,
          thumbnail: this.offerUploads.thumbnail ? { fileObject: this.offerUploads.thumbnail } : this.offer.thumbnail,
          icon: this.offerUploads.icon
            ? { fileObject: this.offerUploads.icon }
            : this.offer.icon ? this.offer.icon : null,
          survey: currentEditOffer.survey || currentOffer.survey || []
        }
        : {
          media: this.activationUploads.media ? { fileObject: this.activationUploads.media } : this.pv.media,
          icon: this.activationUploads.icon
            ? { fileObject: this.activationUploads.icon }
            : this.pv.icon ? { file: this.pv.icon } : null,
          survey: this.editActivation.survey || this.pv.survey || [],
        }

      return {
        ...this.pv,
        ...currentOffer,
        ...this.editActivation,
        ...currentEditOffer,
        ...parsedData,
        pvActivationId: this.pv?._id,
      }
    },
    isBookMarked() {
      return this.user.bookmarked_offers.includes(this.activation._id);
    },
    previewModel() {
      // ToDo: Really need to decide whether to use offer or activation as term for Enginio
      return this.isEditingOffer ? 'ActivationView' : 'PVView'
    },
    previewData() {
      if (!this.offer)
        return null;

      // Select image data to be passed to the preview component
      const offerMedia = {
        media: this.offerUploads.media?.url
            ? [{ file: this.offerUploads.media?.url, fileType: this.offerUploads.media?.type, }]
            : (this.offer?.media || []),
        thumbnail: {
          file: this.offerUploads.thumbnail?.url || this.offer?.thumbnail?.url || null,
        },
        banner: {
          file: this.offerUploads.banner?.url || this.offer?.banner?.url || null,
        },
        icon: this.offerUploads.icon?.url || this.offer?.icon,
      }

      return {
        offer: {
          ...this.offer,
          goodiebag: this.goodiebag,
          ...offerMedia,
          ...this.editOffer,
        },
        activation: {
          ...this.pv,
          fe_media: {
            file: this.activationUploads.media?.url || this.pv?.fe_media?.file || null,
          },
          fe_icon: this.activationUploads.icon?.url || this.pv?.fe_icon || null,
          ...this.editActivation,
        },
        // Since subOffer image data is copied from offer, we use the same source
        subOffer: {
          ...this.subOffer,
          goodiebag: this.goodiebag,
          media: offerMedia.media,
          thumbnail: offerMedia.thumbnail,
          banner: offerMedia.banner,
          icon: offerMedia.icon,
          ...this.editSubOffer,
        }
      }
    },
    previewOptions() {
      switch (this.currentType) {
        case 'StyleDetailsStepConfig':
          return {
            currentStep: 'receipt-input',
            activation: this.previewData.activation,
            offer: this.previewData.offer,
          }
        case 'TermsStepConfig':
          return {
            currentStep: 'receipt-input',
            showTOC: true,
            activation: this.previewData.activation,
            offer: this.previewData.offer,
          }
        case 'ReceiptStepConfig':
          return {
            currentStep: 'receipt-edit',
            activation: this.previewData.activation,
            offer: this.previewData.offer,
            receiptData: {
              receiptItem: 'En produkt',
              receiptDate: '2023-01-01',
              receiptStore: 'En butik',
              receiptItemCost: '1000 kr',
            },
          }
        case 'ProductRegistrationStepConfig':
          return {
            currentStep: 'registration',
            activation: this.previewData.activation,
            offer: this.previewData.offer,
          }
        case 'SurveyStepConfig':
          return {
            currentStep: 'survey',
            activation: this.previewData.activation,
            offer: this.previewData.offer,
          }
        case 'AddressSurveyStepConfig':
          return {
            currentStep: 'address',
            activation: this.previewData.activation,
            offer: this.previewData.offer,
          }
        case 'ConfirmationStepConfig':
          return {
            currentStep: 'done',
            activation: this.previewData.activation,
            offer: this.previewData.offer,
          }
        case 'CashbackStepConfig':
          return {
            currentStep: 'cashback',
            activation: this.previewData.activation,
            offer: this.previewData.offer,
          }
        case 'ActivationStepConfig':
          return {
            activation: this.previewData.offer, // ToDo: Change activation key to offer in ActivationView
            collection: this.goodiebag,
          }
        case 'ReturnSurveyStepConfig':
          return {
            activation: this.previewData.subOffer,
            collection: this.goodiebag,
          }
        case 'EmailConfirmationStepConfig': // ToDo: Implement preview
        default:
          return {}
      }
    },
    previewDimensions() {
      switch (this.previewDevice) {
        case 1:
          return {
            width: 375,
            height: 812,
            zoom: 1,
            showScrollbar: false
          }
        case 2:
          return {
            width: 636,
            height: 848,
            zoom: 848 / 636,
          }
        case 3:
        default:
          return {
            width: 1080,
            height: 848,
            zoom: 1.15,
          }
      }
    },
    companyId() {
      return this.$store.getters.company?._id || null;
    },
    pvCompanyId() {
      return this.$store.getters.company?.pv_company_id || null;
    },
    pvId() {
      if (this.offer?.external_link?.includes('/pv/')) {
        const link = this.offer.external_link;
        const index = link.indexOf('/pv/');
        const segment = link.substring(index + 4);
        return segment.split('/').shift();
      }

      return null;
    },
    collectionId() {
      return this.goodiebag?._id || null;
    },
    activationIsSupported() {
      return this.isActivationSupported(this.offer, this.pv);
    },
    stepName() {
      return this.currentType.replace('StepConfig', '');
    },
    nextButtonText() {
      if (this.selectedStepIndex < this.activationSteps.length - 1) {
        return 'Next step'
      }
      return ''
    },
    publishAllowed() {
       return this.offer.document_state !== 'Published';
    },
    unPublishAllowed() {
      return this.offer.document_state === 'Published' || this.offer.document_state === 'PublishDraft';
    },
    hasChanges() {

      if (Object.keys(this.editOffer).length > 0)
            return true

      if (Object.keys(this.editActivation).length > 0)
          return true;

      if (Object.keys(this.offerUploads).length > 0)
          return true;

      if ((this.editOffer?.media !== undefined && this.offer?.media !== undefined) &&
        Object.keys(this.editOffer?.media).length > 0 && (Object.keys(this.editOffer?.media).length ) !== (this.offer?.media && Object.keys(this.offer?.media).length)) {
        return true;
      }

      if (this.editOffer?.media && this.editOffer?.media?.length > 1) {
        let index = 0;
        for (const media of this.offer.media) {
          if (media._id !== this.editOffer.media[index]._id)
              return true; // image order has changed
          index++;
        }
      }

      return false;
    }
  },
  async mounted() {
    await this.$store.dispatch('getPickedCompany');
    await this.getData();
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/pages/CompanyActivation";

</style>
